/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Filter_ToInputs */



/**
* | output |
* | --- |
* | "To" |
*
* @param {Tournaments_Filter_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_filter_to = /** @type {((inputs?: Tournaments_Filter_ToInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Filter_ToInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hasta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Até")
	if (locale === "it") return /** @type {LocalizedString} */ ("Al")
	return /** @type {LocalizedString} */ ("To")
});